import * as turf from '@turf/turf'

export const getStandarizedCoordinates = (validCoordinates) => {
    // We have an array of coordinates to display the waypoints, but we want to be more accurate so for each point
    // we are going to get intermediate points that will consider the great circle of the earth. This is fine on 
    // short distances, but it looks wrong if waypoints are really far away from each other
    let improvedArrayOfCoordinates = []
    for (let index = 0; index < validCoordinates.length; index++) {
        const coordinates = validCoordinates[index]
        const nextCoordinates = validCoordinates[index + 1]

        if (nextCoordinates === undefined) {
            improvedArrayOfCoordinates.push(coordinates)
        } else {
            const from = turf.point(coordinates)
            const to = turf.point(nextCoordinates)
            const distance = turf.distance(from, to)

            // Do it only for small distances to improve performance, as there is almost no visual shift for very small distances
            if (distance > 100) {
                // Creating a set of intermediate coordinates between two route points that are distance more than 100km
                const newIntermediateCoordinates = turf.greatCircle(coordinates, nextCoordinates, { npoints: 35 })
                // `greatCircle` can return array of coordinates, or an array of arrays of coordinates lol
                newIntermediateCoordinates.geometry.coordinates.forEach(coordinatesOrArrayOfCoordinates => {
                    if (typeof coordinatesOrArrayOfCoordinates[0] === 'number') {
                        improvedArrayOfCoordinates.push(coordinatesOrArrayOfCoordinates)
                    } else {
                        coordinatesOrArrayOfCoordinates.forEach(coordinates => {
                            improvedArrayOfCoordinates.push(coordinates)
                        })
                    }
                })
            } else {
                improvedArrayOfCoordinates.push(coordinates)
            }
        }
    }

    const arrayOfCoordinates = []

    let hasCrossed180thMeridianFromEast = false
    let hasCrossed180thMeridianFromWest = false
    
    for (let index = 0; index < improvedArrayOfCoordinates.length; index++) {
        let routeWaypoint = improvedArrayOfCoordinates[index]
        let longitude = routeWaypoint[0]
        let routePreviousWaypoint = improvedArrayOfCoordinates[index - 1]

        /* 
            If we have only 2 points (origin and destination) then we can't make and determination in which direction
            the aircraft is heading, so we display the line as it is between two points, we haven't seen so far any cases
            where a decoded route returned no intermediate points, but if that happened we could have a problem e.g.
            Aircraft departing from Tokyo in Japan to San Francisco in California, it's an obvious for us that it will pass
            through 180th meridian, but in this case the line will be displayed connecting two airports passing from east to west
            through Asia, Europe, North Atlantic Ocean, and most of United States. In this case we really don't know if the route 
            is actually planned to go through what seems to be less obvious choice. Maybe the user really plans to take a long "trip".
            
            This can be better described here: https://macwright.com/2016/09/26/the-180th-meridian.html. Anyway, we normally always have
            some intermediate points, so when it passes through 180th meridian, then we are able to determinate if it was approached from
            east or west and add/subtract 360 degrees accordingly. This needs to be determinated by us and it's also better described
            here: https://github.com/mapbox/mapbox-gl-js/issues/3250
        */ 
        if (improvedArrayOfCoordinates.length > 2) {
            // Any comments found in this section applies also on "reverse" to the case found below where an aircraft crosses
            // 180th meridian from the west. It's intentionally left not DRY for readability.
            if (hasCrossed180thMeridianFromEast) {
                // Once we have determinated that the 180th meridian was crossed from east, then we add 360 automatically to all
                // the coordinates that occur after it was crossed, it could potentially display wrong results, if the route
                // had a crossing of the meridian and a planned turning back, which I hardly can think of such a case happening
                longitude += 360
            } else if (!hasCrossed180thMeridianFromWest && longitude < 0 && routePreviousWaypoint !== undefined && routePreviousWaypoint[0] > 0) {
            /*
                At this point we know that 1. The 180th meridian was approached from east or 2. Prime meridian was approached from west
                What would be the best approach to actually determinate it? Longitude values near 180th meridian are higher than those
                near the prime meridian, so if we make both longitude values positive, sum them together, then if we get a value
                higher than 180 it would mean that it was approached on 180th meridian. This should be a very secure calculation and it 
                would fail only in very unlikly situations like where the pilot decides to travel more than half of the size of the planet 
                to the destination and we didn't get any waypoints, or in between  
            */
                if ((longitude * -1) + routePreviousWaypoint[0] >= 180) {
                    hasCrossed180thMeridianFromEast = true
                    longitude += 360 
                }
            }

            // From west case
            if (hasCrossed180thMeridianFromWest) {
                longitude -= 360
            } else if (!hasCrossed180thMeridianFromEast && 
                    longitude > 0 && routePreviousWaypoint !== undefined && routePreviousWaypoint[0] < 0) {
                if (longitude + (routePreviousWaypoint[0] * -1) >= 180) {
                    hasCrossed180thMeridianFromWest = true
                    longitude -= 360 
                }
            }
        }
        
        arrayOfCoordinates.push([longitude, routeWaypoint[1]])
    }

    return arrayOfCoordinates
}